import {
  css
} from 'lit';

export const CommonButtonStyle = css`
.lds-button {
  background-color: var(--lds-color-button-background);
  border: var(--lds-border-button-width) solid var(--lds-color-button-border);
  border-radius: var(--lds-radius-button);
  box-shadow: var(--lds-shadow-button) var(--lds-color-button-shadow);
  color: var(--lds-color-button-foreground);
  cursor: var(--lds-animation-button-cursor);
  display: inline-block;
  font-family: var(--lds-typography-button-font-family);
  font-size: var(--lds-typography-button-font-size);
  font-weight: var(--lds-typography-button-font-weight);
  line-height: var(--lds-typography-button-line-height);
  margin-top: var(--lds-spacing-button-margin-top);
  margin-right: var(--lds-spacing-button-margin-right);
  margin-bottom: var(--lds-spacing-button-margin-bottom);
  margin-left: var(--lds-spacing-button-margin-left);
  padding-top: calc(var(--lds-spacing-button-padding-top) - var(--lds-border-button-width));
  padding-right: calc(var(--lds-spacing-button-padding-right) - var(--lds-border-button-width));
  padding-bottom: calc(var(--lds-spacing-button-padding-bottom) - var(--lds-border-button-width));
  padding-left: calc(var(--lds-spacing-button-padding-left) - var(--lds-border-button-width));
  text-decoration: var(--lds-typography-button-text-decoration);
  transition: var(--lds-animation-button-transition);
}

.lds-button lds-icon.button-icon {
  --lds-spacing-icon-margin-top: var(--lds-spacing-button-subcomponent-icon-margin-top);
  --lds-spacing-icon-inline-height: var(--lds-spacing-button-subcomponent-icon-height);
  --lds-spacing-icon-inline-width: var(--lds-spacing-button-subcomponent-icon-width);
}

.lds-button lds-icon.button-icon.before {
  --lds-spacing-icon-margin-right: var(--lds-spacing-button-subcomponent-icon-margin-between);
}

.lds-button lds-icon.button-icon.after {
  --lds-spacing-icon-margin-left: var(--lds-spacing-button-subcomponent-icon-margin-between);
}

.lds-button:focus,
.lds-button.focus {
  outline-color: var(--lds-color-button-focus-outline);
  outline-offset: var(--lds-border-button-focus-outline-offset);
  outline-style: var(--lds-border-button-focus-outline-style);
  outline-width: var(--lds-border-button-focus-outline-width);
  box-shadow: var(--lds-shadow-button-focus) var(--lds-color-button-focus-shadow);
  text-decoration: var(--lds-typography-button-text-decoration);

  /* helps with border overlap in button groups */
  z-index: 2;
}

.lds-button:hover,
.lds-button.hover {
  background-color: var(--lds-color-button-background-hover);
  border-color: var(--lds-color-button-border-hover);
  color: var(--lds-color-button-foreground-hover);

  /* helps with border overlap in button groups */
  z-index: 1;
}

.lds-button:active,
.lds-button.active {
  background-color: var(--lds-color-button-background-active);
  border-color: var(--lds-color-button-border-active);
  color: var(--lds-color-button-foreground-active);
}

/* DISABLED ELEMENT STATE OVERRIDES */

.lds-button.disabled,
.lds-button[disabled] {
  background-color: var(--lds-color-button-background-disabled);
  border-color: var(--lds-color-button-border-disabled);
  border-width: var(--lds-border-button-width-disabled);
  box-shadow: var(--lds-shadow-button-disabled);
  color: var(--lds-color-button-foreground-disabled);
  cursor: var(--lds-animation-button-cursor-disabled);
  padding-top: calc(var(--lds-spacing-button-padding-top) - var(--lds-border-button-width-disabled));
  padding-right: calc(var(--lds-spacing-button-padding-right) - var(--lds-border-button-width-disabled));
  padding-bottom: calc(var(--lds-spacing-button-padding-bottom) - var(--lds-border-button-width-disabled));
  padding-left: calc(var(--lds-spacing-button-padding-left) - var(--lds-border-button-width-disabled));
}

.lds-button.disabled:hover,
.lds-button[disabled]:hover,
.lds-button.disabled.hover,
.lds-button[disabled].hover {
  background-color: var(--lds-color-button-background-disabled-hover);
  border-color: var(--lds-color-button-border-disabled-hover);
  color: var(--lds-color-button-foreground-disabled-hover);
}

.lds-button.disabled:active,
.lds-button[disabled]:active,
.lds-button.disabled.active,
.lds-button[disabled].active {
  background-color: var(--lds-color-button-background-disabled-active);
  border-color: var(--lds-color-button-border-disabled-active);
  color: var(--lds-color-button-foreground-disabled-active);
}
`;

export default CommonButtonStyle;
